// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabListSelect_tab-list-segmented__00ni3 .TabListSelect_tab-list-indicator__9oy0k {
  background-color: var(--secondary-color);
  height: 2px;
}
.TabListSelect_tab-list-segmented__00ni3 .TabListSelect_tab-list-tab__J88DT {
  display: flex;
  align-items: center;
  flex-direction: row;
  text-transform: initial;
  font-weight: 600;
  color: var(--text-1);
  font-size: 16px;
  font-style: normal;
  line-height: 1.5; /* 150% */
  letter-spacing: 0.4px;
}
.TabListSelect_tab-list-segmented__00ni3 .TabListSelect_tab-list-tab__J88DT svg {
  margin-right: 5px;
}
.TabListSelect_tab-list-segmented__00ni3 .TabListSelect_tab-list-tab__J88DT.TabListSelect_tab-list-selected__kWusj {
  color: var(--secondary-color);
}
.TabListSelect_tab-list-segmented__00ni3 .TabListSelect_tab-list-tab__J88DT.TabListSelect_tab-list-selected__kWusj svg {
  margin-right: 5px;
}
.TabListSelect_tab-list-segmented__00ni3 .TabListSelect_tab-list-tab__J88DT.TabListSelect_tab-list-selected__kWusj svg path {
  stroke: var(--secondary-color);
}

@media only screen and (max-width: 480px) {
  .TabListSelect_tab-list-segmented__00ni3 .TabListSelect_tab-list-tab__J88DT {
    font-size: 14px;
    padding: 4px 8px;
  }
  .TabListSelect_tab-list-segmented__00ni3 .TabListSelect_tab-list-tab__J88DT svg {
    width: 14px;
    height: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/TabListSelect/TabListSelect.module.scss"],"names":[],"mappings":"AAEE;EACE,wCAAA;EACA,WAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA,EAAA,SAAA;EACA,qBAAA;AAFJ;AAGI;EACE,iBAAA;AADN;AAGI;EACE,6BAAA;AADN;AAEM;EACE,iBAAA;AAAR;AACQ;EACE,8BAAA;AACV;;AAMA;EAEI;IACE,eAAA;IACA,gBAAA;EAJJ;EAKI;IACE,WAAA;IACA,YAAA;EAHN;AACF","sourcesContent":[".tab-list-segmented {\n  // border: 1px solid var(--secondary-color);\n  .tab-list-indicator {\n    background-color: var(--secondary-color);\n    height: 2px;\n  }\n\n  .tab-list-tab {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    text-transform: initial;\n    font-weight: 600;\n    color: var(--text-1);\n    font-size: 16px;\n    font-style: normal;\n    line-height: 1.5; /* 150% */\n    letter-spacing: 0.4px;\n    svg {\n      margin-right: 5px;\n    }\n    &.tab-list-selected {\n      color: var(--secondary-color);\n      svg {\n        margin-right: 5px;\n        path {\n          stroke: var(--secondary-color);\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .tab-list-segmented {\n    .tab-list-tab {\n      font-size: 14px;\n      padding: 4px 8px;\n      svg {\n        width: 14px;\n        height: 14px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-list-segmented": `TabListSelect_tab-list-segmented__00ni3`,
	"tab-list-indicator": `TabListSelect_tab-list-indicator__9oy0k`,
	"tab-list-tab": `TabListSelect_tab-list-tab__J88DT`,
	"tab-list-selected": `TabListSelect_tab-list-selected__kWusj`
};
export default ___CSS_LOADER_EXPORT___;
